// extracted by mini-css-extract-plugin
export default {"timerange":"goals_timerange__uyF57","emphasis":"goals_emphasis__p4EV7","normalText":"goals_normalText__MVqPX"};